import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { taskMiddleware } from "react-palm/tasks";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./assets/fonts/FormaDJRBanner-Bold-Edu.ttf";
import "./assets/fonts/FormaDJRDeck-Regular-Edu.ttf";
import "./assets/fonts/IBMPlexMono-Regular.ttf";

const initialState = {};
// const customKeplerReducer = keplerGlReducer.initialState({
//   uiState: {
//     activeSidePanel: null,
//     currentModal: null
//   }
// });
const reducers = combineReducers({
  // <-- mount kepler.gl reducer in your app
  // keplerGl: customKeplerReducer
});

// using createStore
const store = createStore(
  reducers,
  initialState,
  applyMiddleware(taskMiddleware)
);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
